const testRoutes = [
  {
    path: '/test',
    name: 'TestIndex',
    meta: {
      index: 999
    },
    component: () => import('@/views/test/Index')
  }
]
export default testRoutes
